// src/redux/archerChat/constants.js

export const ARCHER_SEND_MESSAGE      = 'ARCHER_SEND_MESSAGE';
export const ARCHER_MESSAGE_SUCCESS   = 'ARCHER_MESSAGE_SUCCESS';
export const ARCHER_MESSAGE_FAILURE   = 'ARCHER_MESSAGE_FAILURE';
export const ARCHER_TEXT_DELTA        = 'ARCHER_TEXT_DELTA';
export const ARCHER_SET_CONVERSATION  = 'ARCHER_SET_CONVERSATION';
export const ARCHER_SET_DATA          = 'ARCHER_SET_DATA';
export const ARCHER_TOOL_ACTIVE       = 'ARCHER_TOOL_ACTIVE';
export const ARCHER_NEW_CONVERSATION  = 'ARCHER_NEW_CONVERSATION';
export const ARCHER_TOGGLE_WIDGET     = 'ARCHER_TOGGLE_WIDGET';
